import styled from 'styled-components';
import { H2 } from '../../../styles/FontStyles';

import fistHubBackground from '../../../assets/images/backoffice/akasha/ahashaFistHubBackground.png';
import fistHubBackgroundMobile from '../../../assets/images/backoffice/akasha/ahashaFistHubBackgroundMobile.png';

import akasha1 from '../../../assets/images/backoffice/akasha/ahasha1.png';
import akasha2 from '../../../assets/images/backoffice/akasha/ahasha2.png';
import akasha3 from '../../../assets/images/backoffice/akasha/ahasha3.png';
import akasha4 from '../../../assets/images/backoffice/akasha/ahasha4.png';
import akasha5 from '../../../assets/images/backoffice/akasha/ahasha5.png';
import akasha6 from '../../../assets/images/backoffice/akasha/ahasha6.png';

import { Box } from '../../../styles/GlobalComponents';

export const AkashaTitle = styled.p`
  background: linear-gradient(
    90deg,
    #2e4963 0%,
    #37b0c0 33%,
    #46a894 71%,
    #46536b 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
`;

export const AkashaPackageH2 = styled(H2)`
  display: block;
  background: linear-gradient(
    90deg,
    #2e4963 0%,
    #37b0c0 33%,
    #46a894 71%,
    #46536b 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

// export const Tab = styled.div`
//   display: flex;
//   align-items: center;
//   color: #fff;
//   border-radius: 50px;
//   padding: 12px;
//   margin-top: 10px;
//   background: linear-gradient(90deg, #084851 0%, #01899c 100%);
//   width: 75%;

//   @media (max-width: 800px) {
//     width: 100%;
//     // flex-direction: column;
//   }
// `;

export const AkashaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  /* margin: 0 140px; */
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    margin: 0;
  }

  > {
    :nth-child(1) {
      background: url(${akasha1});
      background-size: contain;
      background-repeat: no-repeat;
    }
    :nth-child(2) {
      background: url(${akasha2});
      background-size: contain;
      background-repeat: no-repeat;
    }
    :nth-child(3) {
      background: url(${akasha3});
      background-size: contain;
      background-repeat: no-repeat;
    }
    :nth-child(4) {
      background: url(${akasha4});
      background-size: contain;
      background-repeat: no-repeat;
    }
    :nth-child(5) {
      background: url(${akasha5});
      background-size: contain;
      background-repeat: no-repeat;
    }
    :nth-child(6) {
      background: url(${akasha6});
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
`;

export const GridItem = styled(Box)<{
  selected: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.neutral0};
  border-radius: 30px;
  padding: 20px;
  text-align: center;
  ${({ selected, theme }) =>
    selected &&
    `
      background-color: ${theme.colors.secondaryBlue};
    `}
  margin-bottom:0;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;

export const PackagesTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 140%;
  margin-top: 60px;
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 0.02em;

  background: linear-gradient(
      83.61deg,
      #2e4963 0.49%,
      #37b0c0 32.7%,
      #46a894 69%,
      #46536b 96.91%
    ),
    #050505;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: #0caacd;
  margin: 34px 0;
`;

export const AkashaFirstHub = styled(Box)<{
  selected: boolean;
}>`
  display: flex;
  width: 750px;
  background: url(${fistHubBackground});
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 30px;
  padding: 30px 20px;
  text-align: center;
  margin-bottom: 0;

  @media (max-width: 1000px) {
    width: 100%;
    flex-direction: column;
    background: url(${fistHubBackgroundMobile});
    background-size: contain;
    background-repeat: no-repeat;
  }
`;
